<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(coursetype.id)" v-if="$can('coursetype-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  name="coursetype.name"
                  v-model="coursetype.name"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypes.name')"
                  :error-messages="errors.collect('coursetype.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="coursetype.category"
                  v-model="coursetype.category"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypes.category')"
                  :error-messages="errors.collect('coursetype.category')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-autocomplete
                  name="coursetype.coursetypegroup_id"
                  v-model="coursetype.coursetypegroup_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('coursetype.coursetypegroup_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <!--<v-flex md3 sm6 xs12>
                                <v-text-field
                                    name="coursetype.code"
                                    v-model="coursetype.code"
                                    v-validate="'max:255'"
                                    :label="$t('coursetypes.code')"
                                    :error-messages="errors.collect('coursetype.code')"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="coursetype.teaching_plan"
                  v-model="coursetype.teaching_plan"
                  v-validate="'max:255'"
                  :label="$t('coursetypes.teaching_plan')"
                  :error-messages="errors.collect('coursetype.teaching_plan')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  name="coursetype.teaching_material"
                  v-model="coursetype.teaching_material"
                  v-validate="'max:255'"
                  :label="$t('coursetypes.teaching_material')"
                  :error-messages="errors.collect('coursetype.teaching_material')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-select
                  name="coursetype.status"
                  v-model="coursetype.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_types_status()"
                  :label="$t('coursetypes.status')"
                  :error-messages="errors.collect('coursetype.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      coursetype: {},
      coursetypegroups: [],
      dictionary: {
        attributes: {
          "coursetype.name": this.$t("coursetypes.name"),
          "coursetype.category": this.$t("coursetypes.category"),
          "coursetype.status": this.$t("coursetypes.status"),
          "coursetype.code": this.$t("coursetypes.code"),
          "coursetype.teaching_plan": this.$t("coursetypes.teaching_plan"),
          "coursetype.teaching_material": this.$t("coursetypes.teaching_material")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.coursetype, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    axios.get(this.API_URL + "coursetypegroups?show_all=true&sort_by=category&sort_order=asc").then((res) => {
      this.coursetypegroups = res.data.data

      if (!this.id) {
        this.coursetype = {}
        this.coursetype = {
          status: this.$getDefaultDropdown(this.$dd_course_types_status())
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.coursetype))

        this.setPageTitle()
      } else {
        this.title = this.$t("coursetypes.update_title")

        axios
          .get(this.API_URL + "coursetype/" + this.id)
          .then((res) => {
            this.coursetype = res.data.data

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.coursetype))

            this.setPageTitle()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    setPageTitle() {
      if (_.has(this.coursetype, "id")) {
        this.page_title = this.$t("coursetypes.edit_coursetype", {
          name: this.coursetype.name
        })
      } else {
        this.page_title = this.$t("coursetypes.new_coursetype")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.coursetype.id) {
              // Create
              axios
                .post(this.API_URL + "coursetype", {
                  name: this.coursetype.name,
                  category: this.coursetype.category,
                  status: this.coursetype.status,
                  coursetypegroup_id: this.coursetype.coursetypegroup_id,
                  code: this.coursetype.code,
                  teaching_plan: this.coursetype.teaching_plan,
                  teaching_material: this.coursetype.teaching_material
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.coursetype = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.coursetype))

                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/coursetypes/edit/${vm.coursetype.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "coursetype", {
                  id: this.coursetype.id,
                  name: this.coursetype.name,
                  category: this.coursetype.category,
                  status: this.coursetype.status,
                  coursetypegroup_id: this.coursetype.coursetypegroup_id,
                  code: this.coursetype.code,
                  teaching_plan: this.coursetype.teaching_plan,
                  teaching_material: this.coursetype.teaching_material
                })
                .then((res) => {
                  vm.coursetype = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.coursetype))

                  vm.setPageTitle()

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetype/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetypes")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
